import { RouteTypes } from 'consts';

// Las rutas comentadas pertenecen a la fase 2

// Constantes que se usan en este archivo
const listadoPracticasConstant = 'Listado de prácticas';
const auditCuadernoConstant = 'Auditar cuaderno';
const certificadoPracticasConstant = 'Certificados de prácticas';

const getReportConfig = (childs) => {
  return {
    link: '#',
    label: 'Informes',
    icon: 'informes',
    childs,
  };
};

const getModuloAdminstracion = (childs) => {
  return {
    link: '#',
    label: 'Panel administración',
    icon: 'informes',
    childs,
  };
};

const altaAdministradores = {
  link: RouteTypes.ALTA_ADMINISTRADORES,
  label: 'Alta Administradores',
};

const altaSupervisores = {
  link: RouteTypes.ALTA_SUPERVISORES,
  label: 'Alta Supervisores',
};

const altaVisualizadores = {
  link: RouteTypes.ALTA_VISUALIZADORES,
  label: 'Alta Visualizadores',
};

const altaGestores = {
  link: RouteTypes.ALTA_GESTORES,
  label: 'Alta Gestores',
};

const altaFormadores = {
  link: RouteTypes.ALTA_FORMADORES,
  label: 'Alta Formadores',
};
const altaAlumnos = {
  link: RouteTypes.ALTA_ALUMNOS,
  label: 'Alta Alumnos',
};

const coursesRoute = {
  link: RouteTypes.COURSE,
  icon: 'cursos',
  label: 'Listado de cursos',
};
const coursesRemainingClosing = {
  link: RouteTypes.REPORT_COURSES_CLOSING,
  label: 'Cursos pendientes de cierre',
};
const perfil = {
  link: RouteTypes.PROFILE,
  icon: 'login',
  label: 'Perfil',
};
const reportHours = {
  link: RouteTypes.REPORT_HOURS,
  label: 'Informe horas',
};
const reportInstructorHours = {
  link: RouteTypes.REPORT_HOURS_INSTRUCTOR,
  label: 'Informe horas formación instructor',
};
const reportInfraestructure = {
  link: RouteTypes.REPORT_INFRAESTRUCTURE,
  label: 'Informe infraestructura',
};

// Array routes
export const menuItemsAlumno = [
  {
    link: RouteTypes.HOME,
    icon: 'list_practicas',
    label: listadoPracticasConstant,
  },
  coursesRoute,
  getReportConfig([reportHours, reportInfraestructure]),
];

export const menuItemsAlumnoExtActive = [
  perfil,
  {
    link: RouteTypes.HOME,
    icon: 'list_practicas',
    label: listadoPracticasConstant,
  },
  {
    link: RouteTypes.CREATE,
    icon: 'practica',
    label: 'Crear práctica',
  },
  coursesRoute,
  getReportConfig([reportHours, reportInfraestructure]),
];
export const menuItemsAlumnoIntActive = [
  {
    link: RouteTypes.HOME,
    icon: 'list_practicas',
    label: listadoPracticasConstant,
  },
  {
    link: RouteTypes.CREATE,
    icon: 'practica',
    label: 'Crear práctica',
  },
  coursesRoute,
  getReportConfig([reportHours, reportInfraestructure]),
];

export const menuItemsInstructor = [
  {
    link: RouteTypes.HOME,
    icon: 'list_practicas',
    label: listadoPracticasConstant,
  },
];

export const menuItemsInstructorActive = [
  {
    link: RouteTypes.HOME,
    icon: 'list_practicas',
    label: listadoPracticasConstant,
  },
  getReportConfig([reportInstructorHours]),
];

export const menuItemsFormador = [
  {
    link: RouteTypes.HOME,
    icon: 'list_practicas',
    label: listadoPracticasConstant,
  },
  {
    link: RouteTypes.AUDIT,
    icon: 'auditar',
    label: auditCuadernoConstant,
  },
  coursesRoute,
  getReportConfig([reportHours, reportInfraestructure, reportInstructorHours]),
  /*{
    link: RouteTypes.CERTIFICADOS_PRACTICAS,
    icon: 'doc',
    label: certificadoPracticasConstant,
  },*/
];

export const menuItemsGestor = [
  {
    link: RouteTypes.HOME,
    icon: 'list_practicas',
    label: listadoPracticasConstant,
  },
  {
    link: RouteTypes.AUDIT,
    icon: 'auditar',
    label: auditCuadernoConstant,
  },
  coursesRoute,
  getReportConfig([
    coursesRemainingClosing,
    reportHours,
    reportInfraestructure,
    reportInstructorHours,
  ]),
  /*getModuloAdminstracion([
    altaFormadores,
    altaAlumnos,
  ]),
  */
  {
   link: RouteTypes.CERTIFICADOS_PRACTICAS,
   icon: 'doc',
   label: certificadoPracticasConstant,
  },
];

export const menuItemsAdministrador = [
  {
    link: RouteTypes.HOME,
    icon: 'list_practicas',
    label: listadoPracticasConstant,
  },
  {
    link: RouteTypes.AUDIT,
    icon: 'auditar',
    label: auditCuadernoConstant,
  },
  coursesRoute,
  getReportConfig([
    coursesRemainingClosing,
    reportHours,
    reportInfraestructure,
    reportInstructorHours,
  ]),
  {
    link: RouteTypes.VALIDATION_PHOTOS,
    icon: 'check',
    label: 'Validar fotografía perfil',
  },
  getModuloAdminstracion([
    altaAdministradores,
    altaSupervisores,
    altaVisualizadores,
    altaGestores,
    altaFormadores,
    /*altaAlumnos,
    */
  ]),

  {
    link: RouteTypes.CERTIFICADOS_PRACTICAS,
    icon: 'doc',
    label: certificadoPracticasConstant,
  },
];

export const menuItemsSupervisor = [
  {
    link: RouteTypes.HOME,
    icon: 'list_practicas',
    label: listadoPracticasConstant,
  },
  {
    link: RouteTypes.AUDIT,
    icon: 'auditar',
    label: auditCuadernoConstant,
  },
  coursesRoute,
  getReportConfig([
    coursesRemainingClosing,
    reportHours,
    reportInfraestructure,
    reportInstructorHours,
  ]),
  {
    link: RouteTypes.VALIDATION_PHOTOS,
    icon: 'check',
    label: 'Validar fotografía perfil',
  },
  /*
  getModuloAdminstracion([
    altaAdministradores,
    altaSupervisores,
    altaVisualizadores,
  ]),

  {
    link: RouteTypes.CERTIFICADOS_PRACTICAS,
    icon: 'doc',
    label: certificadoPracticasConstant,
  },
  */
];


export const menuItemsVisualizador = [
  {
    link: RouteTypes.HOME,
    icon: 'list_practicas',
    label: listadoPracticasConstant,
  },
  {
    link: RouteTypes.AUDIT,
    icon: 'auditar',
    label: auditCuadernoConstant,
  },
  coursesRoute,
  getReportConfig([
    coursesRemainingClosing,
    reportHours,
    reportInfraestructure,
    reportInstructorHours,
  ]),
  {
    link: RouteTypes.VALIDATION_PHOTOS,
    icon: 'check',
    label: 'Validar fotografía perfil',
  },
  /*
  getModuloAdminstracion([
    altaAdministradores,
    altaSupervisores,
    altaVisualizadores,
  ]),

  {
    link: RouteTypes.CERTIFICADOS_PRACTICAS,
    icon: 'doc',
    label: certificadoPracticasConstant,
  },
  */
];
